module.exports = __webpack_public_path__ + "img/article.b9f926fb.svg";